<!-- permission button group -->
<template>
  <div>
    <template v-if="unfoldBtns.length > 0">
      <template v-for="btn in unfoldBtns">
        <el-button v-if="!btn.children?.length" :key="btn.label" type="text" size="mini" @click.stop="btn.event(row)">
          {{ btn.label }}
        </el-button>

        <mg-dropdown-button
          v-else
          :key="btn.label"
          :cacheKey="btn.cacheKey"
          type="text"
          :data="btn.children"
          @command="(item) => item.event(row, item)"
        >
          {{ btn.label }}
        </mg-dropdown-button>
      </template>
    </template>

    <template v-if="printBtns.length > 0">
      <mg-dropdown-button
        v-for="btn in printBtns"
        :key="btn.label"
        :cacheKey="btn.cacheKey"
        type="text"
        :data="btn.children"
        @command="(item) => item.event(row, item)"
      >
        {{ btn.label }}
      </mg-dropdown-button>
    </template>

    <template v-if="foldBtns.length > 0">
      <mg-dropdown-button type="text" :data="foldBtns" @command="(item) => item.event(row, item)">
        {{ $MGUI.i18n.t('更多') }}
      </mg-dropdown-button>
    </template>
  </div>
</template>

<script>
  import { slice } from 'lodash-es'
  export default {
    name: 'mgButtonGroup',

    data() {
      return {
        // 需要折叠的按钮
        foldBtns: [],
        // 不需要折叠的按钮
        unfoldBtns: [],
        // 打印预览按钮
        printBtns: [],
      }
    },

    props: {
      // 按钮对象数组 { label: String, permission: String, event: function}
      buttons: {
        type: Array,
        default: () => [],
      },

      // 按钮是否显示的条件 { 查看: Boolean}
      show: {
        type: Object,
        default: () => {},
      },

      // 是否折叠的临界值
      critical: {
        type: Number,
        default: 3,
      },

      // 所有按钮是否平铺
      flatten: {
        type: Boolean,
        default: true,
      },

      // table 当前行
      row: Object,
    },

    watch: {
      row: {
        handler: function () {
          if (this.flatten) {
            this.flatHandler()
          } else {
            this.foldHandler()
          }
        },
        immediate: true,
      },
    },

    methods: {
      flatHandler() {
        const permissions = this.$route.meta.buttons.map((item) => item.path)

        // all buttons
        const renderBtns = this.buttons.filter(
          (button) => this.show[button.label] && (permissions.includes(button.permission) || button.permission === '')
        )

        this.unfoldBtns = renderBtns
      },

      foldHandler() {
        const permissions = this.$route.meta.buttons.map((item) => item.path)

        // normal buttons
        const renderBtns = this.buttons.filter(
          (button) =>
            !['print', 'preview'].includes(button.permission) &&
            this.show[button.label] &&
            (permissions.includes(button.permission) || button.permission === '')
        )

        // filter print preview and children.length > 0
        this.printBtns = this.buttons.filter(
          (button) =>
            ['print', 'preview'].includes(button.permission) &&
            this.show[button.label] &&
            button?.children.length > 0 &&
            (permissions.includes(button.permission) || button.permission === '')
        )

        // unfold
        this.unfoldBtns = renderBtns.length <= this.critical ? renderBtns : slice(renderBtns, 0, this.critical - 1)

        // fold
        this.foldBtns =
          renderBtns.length <= this.critical ? [] : slice(renderBtns, this.critical - 1, renderBtns.length)
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-button:first-child {
      margin: 0 !important;
    }
    .el-button {
      margin: 0 0 0 10px !important;
    }
    .el-dropdown {
      font-size: 12px !important;
    }
    .el-icon--right {
      margin-left: 0 !important;
    }
    .mg-dropdown-button {
      .el-button--small {
        padding: 3px 0;
        min-width: auto;
      }
    }
  }
</style>
